<div class="container-fluid animated fadeIn">
	<div class="row justify-content-center mt-5 mb-3 d-none">
		<!-- TITLES AND BUTTONS AREA -->
		<div class="col-xl-12">
			<div class="d-flex align-items-center justify-content-between top-area">
				<div class="title-area">
					<div>
						<!--<h2 class="mb-0">{{'settings.pageTitle' | translate}}</h2>-->
						<h2 class="mb-0">{{ 'upload-component.Upload' | translate }}</h2>
					</div>
				</div>
				<div class="buttons-area d-flex align-items-center">
					<!-- filters (hidden) -->
					<div class="">
						<!-- button filters removed -->
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- UPLOAD AREA -->
	<div class="row justify-content-center align-items-center">
		<div class="col upload-wrapper">
			<div class="d-flex flex-column align-items-center">
				<div class="wiz-title">
					{{ 'upload-component.Documents' | translate }}
				</div>
				<div class="badge-icon cool-shadow-1">
					<div class="">
						<i class="fa-solid fa-file-upload"></i>
					</div>
				</div>
				<div class="text-uppercase text-secondary mt-5 mb-4">
					{{ 'upload-component.DocumentsContextualization' | translate }}
				</div>
				<div>
					<eif-custom-button
						[text]="'upload-component.DocumentsUploadStep1' | translate"
						[class]="'mb-0'"
						(action)="navigateToDocumentsUploadStep1()">
					</eif-custom-button>
				</div>
			</div>
		</div>
	</div>
</div>
